"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const jlDataUtils_1 = require("../../utils/jlDataUtils");
const kevelVisibility_1 = require("../../utils/kevelVisibility");
const isValidKevelEvent = (event) => {
    return Boolean(event.adId && event.type && event.clickUrl && event.impressionUrl);
};
const getMatchingEvent = (element, validEvents) => validEvents.find((eventData) => element.getAttribute("data-kevel-banner-ad-id") === eventData.adId);
const KevelAnalytics = ({ events = [], browserCacheEnabled = false, }) => {
    (0, react_1.useEffect)(() => {
        var _a;
        console.log("[KevelAnalytics] Props received - events:", events, "browserCacheEnabled:", browserCacheEnabled);
        const validEvents = events.filter(isValidKevelEvent);
        console.log("[KevelAnalytics] Valid events after filter:", validEvents);
        if (validEvents.length === 0) {
            console.log("[KevelAnalytics] No valid events, returning early");
            return;
        }
        if (browserCacheEnabled) {
            const renderTimestamp = (_a = document
                .querySelector('meta[name="esi-render-time"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("content");
            const isCached = renderTimestamp
                ? Date.now() - parseInt(renderTimestamp) > 5000
                : false;
            if (isCached) {
                console.log("[KevelAnalytics] Response is cached, skipping observation");
                return;
            }
        }
        (0, jlDataUtils_1.addKevelBannersToJlData)(validEvents);
        const observedElements = validEvents.flatMap((eventData) => {
            const selector = `[data-kevel-banner-ad-id="${eventData.adId}"]`;
            console.log("[KevelAnalytics] Querying selector:", selector, "for adId:", eventData.adId, "type:", typeof eventData.adId);
            const elements = Array.from(document.querySelectorAll(selector));
            console.log("[KevelAnalytics] Found", elements.length, "elements for adId:", eventData.adId);
            if (elements.length > 0) {
                elements.forEach((el) => {
                    console.log("[KevelAnalytics] Element DOM attribute:", el.getAttribute("data-kevel-banner-ad-id"));
                });
            }
            if (elements.length === 0) {
                return [];
            }
            return elements;
        });
        console.log("[KevelAnalytics] Total observed elements:", observedElements.length);
        observedElements.forEach((element) => {
            const matchingEvent = getMatchingEvent(element, validEvents);
            if (matchingEvent) {
                console.log("[KevelAnalytics] Calling observeKevelBanner for", matchingEvent.adId);
                (0, kevelVisibility_1.observeKevelBanner)(element, matchingEvent);
            }
        });
        return () => {
            console.log("[KevelAnalytics] Cleanup: removing observations");
            const adIds = validEvents.map((event) => event.adId);
            (0, jlDataUtils_1.removeKevelBannersFromJlDataByAdIds)(adIds);
            observedElements.forEach((element) => {
                const matchingEvent = getMatchingEvent(element, validEvents);
                if (matchingEvent) {
                    (0, kevelVisibility_1.unobserveKevelBanner)(element, matchingEvent);
                }
            });
        };
    }, [events, browserCacheEnabled]);
    return null;
};
exports.default = KevelAnalytics;
